const tableHeaders = [
  {
    text: 'IO Number',
    value: 'ioNumbers'
  },
  {
    text: 'Billing Name as per Xero',
    value: 'billingName'
  },
  {
    text: 'Campaign Name',
    value: 'campaignName'
  },
  {
    text: 'Campaign Type',
    value: 'campaignType'
  },
  {
    text: 'Budget',
    value: 'budget'
  },
  // {
  //   text: 'Revenue Recognized',
  //   value: 'revenueRecognized'
  // },
  // {
  //   text: 'Unrecognized Revenue',
  //   value: 'unrecognizedRevenue'
  // },
  {
    text: 'Capped COGS',
    value: 'cappedCOGS'
  },
  // {
  //   text: 'COGS Used',
  //   value: 'cogs'
  // },
  {
    text: 'Total COGS',
    value: 'cogsTotal'
  },
  {
    text: 'COGS (INF) - Inclusive GST',
    value: 'cogsInf'
  },
  {
    text: 'COGS (INF) - Exclusive GST',
    value: 'cogsNoGST'
  },
  {
    text: 'COGS (others)',
    value: 'cogsOthers'
  },
  {
    text: 'COGS %',
    value: 'cogsInfPercentage'
  },
  {
    text: 'COGS Excess',
    value: 'cogsExcess'
  },
  {
    text: 'Completed Amount',
    value: 'completedAmt'
  },
  {
    text: 'Pending Amount',
    value: 'pendingAmt'
  },
  {
    text: 'AM',
    value: 'AM'
  },
  {
    text: 'CC',
    value: 'CC'
  },
  {
    text: 'Stage',
    value: 'stage'
  },
  // {
  //   text: 'Start Month',
  //   value: 'startDate'
  // },
  // {
  //   text: 'End Month',
  //   value: 'endDate'
  // },
  {
    text: 'First Post Date',
    value: 'firstPostDate'
  },
  {
    text: 'Last Post Date',
    value: 'lastPostDate'
  },
  {
    text: 'Start Month',
    value: 'startMonth'
  },
  {
    text: 'End Month',
    value: 'endMonth'
  },
  {
    text: 'Action',
    value: 'action'
  }
]

const dummyData = [
  {
    name: 'ongoing',
    title: 'Ongoing',
    panel: [0],
    data: []
  },
  {
    name: '24Q1',
    title: 'QUARTER 1',
    panel: [0],
    data: []
  },
  {
    name: '24Q2',
    title: 'QUARTER 2',
    panel: [0],
    data: []
  },
  {
    name: '24Q3',
    title: 'QUARTER 3',
    panel: [0],
    data: []
  },
  {
    name: '24Q4',
    title: 'QUARTER 4',
    panel: [0],
    data: []
  },
  {
    name: 'completed',
    title: 'Completed',
    panel: [0],
    data: []
  }
]

export default {
  tableHeaders,
  dummyData
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/COGSSummary/config.js